<template>
  <v-container>
    <form
      ref="myForm"
      id="checkoutForm"
      :action="pesaFlowIframe.actionURL"
      method="post"
      target="checkoutIframe"
      v-if="pesaFlowIframe"
    >
      <!-- API Client ID -->
      <input
        type="text"
        id="apiClientID"
        name="apiClientID"
        :value="pesaFlowIframe.apiClientID"
        v-show="showInput"
      />

      <!-- Secure Hash -->
      <input type="text" id="secureHash" name="secureHash" :value="pesaFlowIframe.secureHash" v-show="showInput"/>

      <!-- Bill Description -->
      <input
        type="text"
        id="billDesc"
        name="billDesc"
        :value="pesaFlowIframe.billDesc"
        v-show="showInput"
      />

      <!-- Bill Reference Number -->
      <input
        type="text"
        id="billRefNumber"
        name="billRefNumber"
        :value="pesaFlowIframe.billRefNumber"
        v-show="showInput"
      />

      <!-- Currency -->
      <input
        type="text"
        id="currency"
        name="currency"
        :value="pesaFlowIframe.currency"
        v-show="showInput"
      />

      <!-- Service ID -->
      <input
        type="text"
        id="serviceID"
        name="serviceID"
        :value="pesaFlowIframe.serviceID"
        v-show="showInput"
      />

      <!-- Client MSISDN -->
      <fieldset>
        <legend>Phone Number</legend>
        <input
        type="text"
        id="clientMSISDN"
        name="clientMSISDN"
        :value="pesaFlowIframe.clientMSISDN"
        :readonly="true"
      />
      </fieldset>

      <!-- Client Name -->
      <input
        type="text"
        id="clientName"
        name="clientName"
        :value="pesaFlowIframe.clientName"
        v-show="showInput"
      />

      <!-- Client ID Number -->
      <input
        type="text"
        id="clientIDNumber"
        name="clientIDNumber"
        :value="pesaFlowIframe.clientIDNumber"
        v-show="showInput"
      />

      <!-- Client Email -->
      <input
        type="email"
        id="clientEmail"
        name="clientEmail"
        :value="pesaFlowIframe.clientEmail"
        v-show="showInput"
      />

      <!-- Callback URL on Success -->
      <input
        type="url"
        id="callBackURLOnSuccess"
        name="callBackURLOnSuccess"
        :value="pesaFlowIframe.callBackURLOnSuccess"
        v-show="showInput"
      />

      <!-- Picture URL -->
      <input
        type="url"
        id="pictureURL"
        name="pictureURL"
        :value="pesaFlowIframe.pictureURL"
        v-show="showInput"
      />

      <!-- Notification URL -->
      <input
        type="url"
        id="notificationURL"
        name="notificationURL"
        :value="pesaFlowIframe.notificationURL"
        v-show="showInput"
      />

      <!-- Amount Expected -->
      <fieldset>
        <legend>Amount</legend>
        <input
        type="number"
        id="amountExpected"
        name="amountExpected"
        :value="pesaFlowIframe.amountExpected"
        :readonly="true"
      />
      </fieldset>

      <!-- Convenience Fee -->
      <input
        type="number"
        id="convenienceFee"
        name="convenienceFee"
        :value="pesaFlowIframe.convenienceFee"
        v-show="showInput"
      />

      <!-- Submit Button -->
      <input type="submit" value="Submit" v-show="showInput"/>
    </form>
    <!-- Checkout Iframe -->
    <iframe
      ref="iframe"
      name="checkoutIframe"
      width="100%"
      height="600"
      frameborder="0"
    ></iframe>
  </v-container>
</template>
  <script>
export default {
  name: "PESAFLOWIFRAM",
  props: {
    payload: {
      type: Object,
      default: () => {},
    },
    test: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      formData: {
        accountNo: "",
        amount: "",
      },
      dialog: false,
      showInput: false,
    };
  },
  mounted() {
    this.$refs.iframe.style.display = 'none';
    Event.$on("checkout-1", () => {
      this.pay();
    });
  },
  computed: {
    pesaFlowIframe() {
      return this.$store.getters["Checkout/getIframe"];
    },
  },
  methods: {
    pay: function () {
      let data = { ...this.payload };

      if (this.test) {
        data.description = "TESTINGKTL";
      }

      console.log("calling calling ecititzen");

      // this.$store.dispatch("Checkout/getPesaflowIfram", data);
      this.$refs.myForm.submit();
      this.$refs.myForm.style.display = 'none';
      this.$refs.iframe.style.display = 'block';
    },
    removeEscapeCharacters(string) {
      // Replace all the escape characters with their corresponding characters.
      return string.replace(/\\/g, "");
    },
  },
  watch: {
    payload: {
      handler: function () {
        this.formData.amount = this.test ? 1 : this.payload.amount;
        this.formData.accountNo = this.payload.accountNo;
      },
      immediate: true,
    },
    pesaFlowIframe(oldvalue, newvalue) {
      console.log(newvalue);
    },
  },
};
</script>
<style scoped>
form {
  display: grid;
  grid-template-rows: auto;
  row-gap: 0.8em;
  padding: 0.8rem 0;
}
fieldset {
  padding-left: 2%;
  border-radius: 10px;
  border: 1px solid #ccc;
}
legend {
  font-size: 12px;
  font-weight: 200;
}
input {
  display: block;
  height: 4.5vh;
  width: 100%;
  border: none;
  outline: none;
}
/* @media (min-width: 900px) {
  form {
    display: grid;
    grid-template-columns: 35% 35%;
    column-gap: 0.8em;
  }
} */
</style>
  